import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import {process} from '@progress/kendo-data-query';
import RFQMaterilaDetailsComponent from './RFQMaterialDetailCompnent';
import './RFQ.scss';

class RFQMaterialGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: -1,
            materialgridData : [],
            childGrid :[],
            dataState:{
                skip: 0,
                take: 10,
              }
        }
    }

    
    componentDidMount(){

            var prodData=[]
            var childData=[]
        if(this.props.itemData != undefined && this.props.itemData != null) {
            for (var i = 0; i < this.props.itemData.length; i++) {
                if (this.props.itemData[i].PACKAGE_TCO != undefined && this.props.itemData[i].PACKAGE_TCO != '') {
                    if (this.props.itemData[i].GRO_WEI_VAL != undefined && this.props.itemData[i].GRO_WEI_VAL != null) {
                        if (this.props.itemData[i].DIM_WEI_VAL!= undefined && this.props.itemData[i].DIM_WEI_VAL != null) {
                            if (this.props.itemData[i].GRO_WEI_VAL > this.props.itemData[i].DIM_WEI_VAL)
                            this.props.itemData[i].chargableWeight = this.props.itemData[i].GRO_WEI_VAL;
                            else
                            this.props.itemData[i].chargableWeight = this.props.itemData[i].DIM_WEI_VAL;
                        }
                        else {
                            this.props.itemData[i].chargableWeight = this.props.itemData[i].GRO_WEI_VAL;
                        }
                    }
                    else {
                        if (this.props.itemData[i].DIM_WEI_VAL != undefined && this.props.itemData[i].DIM_WEI_VAL != null) {
                            this.props.itemData[i].chargableWeight = this.props.itemData[i].DIM_WEI_VAL;
                        }
                        else {
                            this.props.itemData[i].chargableWeight = 0;
                        }
                    }

                  
                    prodData.push( this.props.itemData[i]);
                   
                } else {
                    // vm.childGridArr.push(vm.items[i]);
                    childData.push(this.props.itemData[i]);
                    
                }
            }
        }
console.log(childData)
        this.setState({materialgridData:prodData })
        this.setState({childGrid:childData})

    }
    expandChange = (event) => {
        const isExpanded =
            event.dataItem.expanded === undefined ?
                event.dataItem.aggregates : event.dataItem.expanded;
        event.dataItem.expanded = !isExpanded;
        event.dataItem.childData = this.state.childGrid;
        this.setState({ ...this.state });
    }
    render()
    {
     
        const grid = (

            <Grid
                ScrollMode="scrollable"
                pageable = {true}
                sortable
                width = {"1000px"}
                data={process(this.state.materialgridData, this.state.dataState)}
                 {...this.state.dataState}
                 onDataStateChange={(e) => {
                    this.setState({ dataState: e.dataState })
                 }}
                 detail={RFQMaterilaDetailsComponent}
                 expandField="expanded"
                 onExpandChange={this.expandChange}
                 >
                 <GridColumn field="PACKAGEDESCRIPTION" title="Handling Unit" width="120px" className ="gridcolumn" />    
                <GridColumn field="QUA_PCS_VAL" title="Quantity"  width="90px" className ="gridcolumn"  /> 
                    
                <GridColumn field="HEIGHT" title="Height"  width="80px" className ="gridcolumn" />
                <GridColumn field="LENGTH" title="Length"  width="80px" className ="gridcolumn" />             
                 
                 <GridColumn field="WIDTH" title="Width"  width="100px" className ="gridcolumn"></GridColumn>
                 <GridColumn field="MEASUOM" title="Unit Of Measure(L,W,H)"  width = "150px" className ="gridcolumn"></GridColumn>
                 <GridColumn field="GRO_WEI_VAL" title="Estimated Gross Weight" width="150px" className ="gridcolumn"></GridColumn>
                 <GridColumn field="DIM_WEI_VAL" title="Dimansional Weight"  width="150px" className ="gridcolumn"></GridColumn>
                 <GridColumn field="chargableWeight" title="Chargeable Weight"  width = "150px" className ="gridcolumn"></GridColumn>  
                 <GridColumn field="GRO_WEI_UNI" title="Unit Of Measure"   className ="gridcolumn" ></GridColumn>             
                 
               
            </Grid>
        );

        return(
            <div>
            <MDBContainer fluid>
           <MDBRow>
                <div className="" id="kendoGrid">
                   {grid}
               </div>
           </MDBRow>
           </MDBContainer>
       </div>
        );
    }
}

export default RFQMaterialGrid;